
<!-- header de rent car con el filtro -->

<usb-navbar-search-categories [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                              [_results]="_results"
                              (emitterNewResults)="emitterNewResults()"
></usb-navbar-search-categories>



<div class="container-color">
<div class="container-limit-general mx-auto">

  <!-- <ng-container *ngIf="_origin == 'RENT-A-CAR'">
    <usb-rent-a-car-filter
                          [arrayFilterAcriss]="arrayFilterAcriss"
                          [currencyAgency]="currencyAgency"
                          (selectedAcrissKeyEmit)="selectFilterAcriss($event)"
    >
    </usb-rent-a-car-filter>
  </ng-container> -->
<div *ngIf="_origin == 'RENT-A-CAR'" class="header-filtro mt-1">
  <div class="bg-top m-0 p-0 row justify-content-center" style="background-color: #f8f8f6;">
  </div>

  <div class="navbar navbar-expand-xg navbar-expand-lg navbar-expand-md align-items-center top-content" style="margin-top: -55px;">
    <div class="col-xg-12 col-lg-12 col-md-12 col-xs-12">
      <div id="slider-shortcuts" class="carouseller" style="overflow-x: hidden; white-space: nowrap; scroll-behavior: smooth;">

        <div class="carouseller__wrap d-flex flex-row justify-content-center">
          <ng-container *ngFor="let carAcriss of arrayFilterAcriss; let i = index">
            <div class="carouseller__list">
              <div style="display: flex; justify-content: center;">
                <div>
                  <div class="car__2" style=" cursor: pointer;">

                    <label>
                    <div class="col mx-1 px-0 filter-car" style="cursor: pointer;">
                      <div #carousel class="content-filter filter-unselected"
                        [ngClass]="{'filter-selected': selectedAcrissKey === carAcriss.key}"
                          style="min-height: 175px !important;"
                        >
                      <div class="col-0">
                        <input type="checkbox" [checked]="selectedAcrissKey === carAcriss.key" style="visibility:hidden;"
                          class="example-margin" color="primary" (change)="selectFilterAcriss($event, carAcriss.key)" >
                      </div>

                        <div class="row m-0 p-0 justify-content-center">
                            <div style="width: 150px; height: 100px; display: flex; align-items: center; justify-content: center; overflow: hidden;border-radius: 4px;">
                              <img [src]="carAcriss.image"
                                  style="width: 100%; height: 100%; object-fit: contain; padding: 8px; background: white;"
                                  class="mb-2"
                                  alt="Car image">
                            </div>
                            <div class="d-flex">
                              <div class="row m-0 p-0 d-flex justify-content-center" style=" width: 100%;line-height: 30px;">

                                <div class=" d-flex flex-column" style="text-align: center;">
                                  <span class="label-mat-checkbox" style="font-size:12px; font-weight: bold;line-height: 1;margin-bottom: 4px;">{{ carAcriss.label}}</span>
                                  <span class="label-mat-checkbox"
                                    style="font-size:12px; color: #000000; font-weight: bold;line-height: 1;">Desde {{currencyAgency?.code}} {{ carAcriss.price | currencyConverterPure: carAcriss.currency : currencyAgency?.code : currencies
                                    | number : "1.2-2" }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>

</div>

<!-- CONTENEDOR PRINCIPAL DE FILTROS Y RESULTADOS -->
<div *ngIf="_origin === 'FLIGHTS'" class="flights-filters-container px-5">

   <div class="flights-carousel-container" *ngIf="sortedFlights.length > 0">
      <button class="carousel-arrow prev" (click)="scrollCarousel(-1)" *ngIf="showPrevArrow">‹</button>

      <div class="flights-carousel" #flightsCarousel>
        <div *ngFor="let flight of sortedFlights" class="flight-card">

          <!-- Aerolínea (con posible salto de línea si el nombre es largo) -->
          <div class="flight-airline">{{ getAirlineNameFromFlight(flight) }}</div>

          <!-- Fecha -->
          <div class="flight-date">{{ getFlightDate(flight) | date:'EEE, d MMM' }}</div>

          <!-- Precio -->
          <div class="flight-price">{{ getFlightPrice(flight) | currency:'USD':'symbol':'1.0-0' }}</div>

          <!-- Duración -->
          <div class="flight-duration">{{ getFlightDuration(flight) }}</div>
        </div>
      </div>

      <button class="carousel-arrow next" (click)="scrollCarousel(1)" *ngIf="showNextArrow">›</button>
    </div>

    <div class="d-flex justify-content-between">
      <div class="d-flex justify-content-between">
        <div class="sorting-buttons" *ngIf="filteredFlights.length > 0">
          <button class="sort-button"
                  [class.active]="currentSort === 'cheapest'"
                  (click)="sortFlights('cheapest')">
            Más barato
          </button>
          <button class="sort-button"
                  [class.active]="currentSort === 'fastest'"
                  (click)="sortFlights('fastest')">
            Más rápido
          </button>
          <button class="sort-button"
                  [class.active]="currentSort === 'recommended'"
                  (click)="sortFlights('recommended')">
            Recomendado
          </button>
        </div>

      </div>

      <div class="d-flex justify-content-between">
        <div class="sorting-buttons" *ngIf="filteredFlights.length > 0">
          <button class="sort-button"
                  [class.active]="currentSort === 'cheapest'"
                  (click)="sortFlights('cheapest')">
            Más opciones de días y tarifas
          </button>
        </div>
      </div>
    </div>

  <div class="filters-sidebar">

    <!-- TABLA DE PRECIOS POR AEROLÍNEA Y ESCALAS (como en la imagen) -->
    <div class="price-table-section" *ngIf="airlineDetails.length > 0">
      <!-- <h4 class="filter-title"></h4> -->
      <table class="price-table">
        <thead>
          <tr>
            <th>Precios por compañía</th>
            <th *ngFor="let airline of airlineDetails">{{ airline.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Directo</td>
            <td *ngFor="let airline of airlineDetails">
              {{ getLowestPriceByAirlineAndStops(airline.code, 0) | currency:'USD':'symbol':'1.0-0' }}
            </td>
          </tr>
          <tr>
            <td>1 Escala</td>
            <td *ngFor="let airline of airlineDetails">
              {{ getLowestPriceByAirlineAndStops(airline.code, 1) | currency:'USD':'symbol':'1.0-0' }}
            </td>
          </tr>
          <tr>
            <td>2 o más escalas</td>
            <td *ngFor="let airline of airlineDetails">
              {{ getLowestPriceByAirlineAndStops(airline.code, 2) | currency:'USD':'symbol':'1.0-0' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<div id="content-result" class="container-fluid">

  <div class="row">
    <div class="col-12 mb-2">
      <!-- CINTILLO DE VUELO -->
      <usb-head-band
                      *ngIf="_actualItinerary"
                      [_actualItinerary]="_actualItinerary"
                      [payloadSearch]="_payload"
                      [formTransports]="formTransports"
                      [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                      [openModalFly]="openModalFly"
                      (updateFlyEmitter)="reloadItinerary()"
      >
    </usb-head-band>
    </div>

    <div id="main-content" class="col-xg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="row">
        <div id="category-result-component" class="d-flex flex-column" style="width: 75%;">

<ng-container *ngIf="!reloadSearching && paymentAgencyActive">

  <ng-container *ngIf="_results && _results.length > 0 && _results!=undefined else noResultsFound">
    <div *ngFor="let result of _results; let i = index" class="single-result" [ngStyle]="{'padding-bottom': visualMap ? '0px' : '50px'} ">
      <usb-category-result
                          #categoryResult
                          [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                          [reloadSearching]="reloadSearching"
                          [_actualItinerary]="_actualItinerary"
                          [payload]="getPayloadCategory(result?.categoryName, i)"
                          [results]="result"
                          [origin]="_origin"
                          [tabSelected]="_tabSelected"
                          [resultPaged]="_resultPaged"
                          [categoryName]="result?.categoryName"
                          [_form]="_form"
                          [_multiModal]="multiModal"
                          [_payloadForm]="payloadForm"
                          [_pax]="pax"
                          [_applyFilter]="_applyFilter"
                          [deleteProduct]="deleteProduct"
                          [_paxAdults]="paxAdults"
                          [_paxChildren]="paxChildren"
                          [index]="i"
                          [formTransports]="formTransports"
                          [currencies]="currencies"
                          [categoryId]="categoryId"
                          [openModalResearch]="openModalResearch"
                          [paymentAgencyActive]="paymentAgencyActive"
                          [eventModifiedTransportPriceSelectedReturn]="eventModifiedTransportPriceSelectedReturn"
                          [qtyProductValid]="qtyProductValid"
                          (qtyProductValidDecrementEmmit)="qtyProductValidDecrement()"
                          (isLoading)="_onLoading($event)"
                          (_filtersRentacar)="_filtersRentacar($event)"
                          (arrayOut)="updateArray($event)"
                          (isMultiModal)="_onMultimodal($event)"
                          (payload_)="loadPaylod($event)"
                          (emitReSearch)="_emitReSearch($event)"
                          (emitViewMap)="onMapToggle($event)"
                          (openModalFly)="openModalFlyCreate()"
                          (reloadEditPencilEmitter)="reloadEditPencilEmitter()"
                          (resultsRentacarAcriss)="rentacarAcriss($event)"

        >
      </usb-category-result>
    </div>
  </ng-container>
</ng-container>

 <ng-container *ngIf="visualMap">

            <app-map-view *ngIf="_origin === 'HOTELS' || _origin === 'TOURS'"
              [coordinatesArr]="coordinatesArr"
              [currencies]="currencies"
              [currencyAgency]="currencyAgency"
              [clientSetting]="getClientsSettingAppBooking"
              mapMode="general"
              (selectProductFromMap)="selectProductFromMap($event)">
            </app-map-view>

            <app-map-view *ngIf="_origin === 'TRANSPORTS'"
              mapMode="transfer"
              [pickupData]="pickupLocation"
              [dropoffData]="dropoffLocation">
            </app-map-view>
  </ng-container>


          <ng-template #noResultsFound>
            <div class="col-12 pt-10 text-center">
              <!-- <h4>No results found for this search</h4> -->
            </div>
          </ng-template>

        </div>
        <div id="left-sidebar" class="d-flex flex-column" style="width: 25%; gap: 15px;">
          <div class="row mb-2" id="itinerary-component">
            <div class="col-xg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <usb-cart-sidebar
                *ngIf="_actualItinerary"
                [_actualItinerary]="_actualItinerary"
                [styleSidebar]="styleSidebar"
                [currencyAgency]="currencyAgency"
                [permissions]="permissionsMap"
                [currencies]="currencies"
                [clientsSettingAppBooking]="getClientsSettingAppBooking"
                [currentCategory]="currentCategoryName"
                (itemRemove)="onItemRemove($event)"
              ></usb-cart-sidebar>
            </div>
          </div>
          <div class="row" id="visited-component" *ngIf="!viewMap && _actualItinerary">
            <div class="col-xg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
               <usb-suggestion
                                *ngIf="currencyAgency && _actualItinerary"
                                [actualItinerary]="_actualItinerary"
                                [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                                [currencies]="currencies"
                                [currencyAgency]="currencyAgency"
                                [paymentAgencyActive]="paymentAgencyActive"
                                (reloadEmmit)="reloadEmmit()"></usb-suggestion>
            </div>
          </div>
        </div><!-- left-sidebar -->
      </div>
    </div><!-- /main-content -->
  </div>
</div>
</div>
</div>




<ng-template #templateRooms>
  <div *ngIf="multiModal">
    <ng-container *ngFor="let result of _results; let index = index" class="single-result">
      <div style="background-color: #032541 !important; color: #fff !important; height:44px">
        <button id="bt" class="btn btn-link btn-block text-white clearfix" (click)="isCollapsed[index] = !isCollapsed[index]"
          [attr.aria-expanded]="!isCollapsed[index]" [attr.aria-controls]="'collapseViewMore-' + index" accordion-heading>
          <div class="pull-left float-left">{{getPayloadCategory(result?.categoryName, index).destination}}</div>
          <div id="{{ 'check-p' +index }}" class="badge badge-danger float-right pull-right">pending</div>
          <div id="{{ 'check-r' +index }}" class="badge badge-info float-right pull-right" style="display:none;">ready
          </div>
          <i style="color:white" class="pull-right float-xs-right glyphicon"
            [ngClass]="{'glyphicon-chevron-down': group?.isOpen, 'glyphicon-chevron-right': !group?.isOpen}"></i>
        </button>
      </div>

    </ng-container>
    <div class="flex-row py-3 px-2 ">
      <button type="button" class="pull-right btn btn-sm btn-usblick" (click)="_redirectTo('TRANSPORTS');">Continuar</button>
    </div>
    <br>
  </div>
</ng-template>
